import { withI18n } from 'react-i18next';
import EmailClaimCard from './EmailClaimCard';

export const pureComponent = EmailClaimCard;
export default withI18n()(EmailClaimCard);
